import { render, staticRenderFns } from "./QRCodeModal.vue?vue&type=template&id=70886544&scoped=true"
import script from "./QRCodeModal.vue?vue&type=script&lang=js"
export * from "./QRCodeModal.vue?vue&type=script&lang=js"
import style0 from "./QRCodeModal.vue?vue&type=style&index=0&id=70886544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70886544",
  null
  
)

export default component.exports